import {
  Button,
  Container,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  Stack,
  useTheme,
  useMediaQuery,
  Paper,
  alpha,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
// import Header from "../Components/Header";
import { useTranslation } from "react-i18next";
import img from "./images/translate.png";
import ima2 from "./images/transcript (1).png";
import ima3 from "./images/interpreter.png";
import headerImg from "../Components/images/hexxader2.jpg";
import Footer from "../Components/Footer";
import ScrollToTop from "../Components/ScrollToTop";
import { useEffect } from "react";
import { motion } from "framer-motion";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const direction = ["ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ku"].includes(i18n.language) ? "right" : "left";

  const services = [
    {
      icon: img,
      title: t("HomeTranslation"),
      description: t("HomeTranslationTitle"),
      link: "/Translations",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    },
    {
      icon: ima3,
      title: t("HomeInterpreting"),
      description: t("HomeInterpretingTitle"),
      link: "/Interpreting",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    },
    {
      icon: ima2,
      title: t("HomeTranscriptions"),
      description: t("HomeTranscriptionsTitle"),
      link: "/Transcriptions",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    },
  ];

  return (
    <Box sx={{ direction, textAlign, minHeight: "100vh" }}>
      {/* Header Component - Moved from Header.js */}
      <Box
        component="img"
        src={headerImg}
        alt="Kurdish Translation Services Header"
        sx={{
          width: "100%",
          height: "auto",
          mt: { xs: 7, sm: 8 },
          display: "block",
          objectFit: "cover",
        }}
        loading="lazy"
      />

      {/* Hero Section with Gradient Background */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          py: { xs: 6, md: 10 },
          mt: { xs: 7, sm: 8 },
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            variant="h4"
            component="p"
            sx={{
              fontSize: { xs: 20, md: 28 },
              fontWeight: 700,
              lineHeight: 1.6,
              textAlign: "center",
              color: "white",
              maxWidth: "900px",
              mx: "auto",
              textShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            {t("Home1")}
          </Typography>
        </Container>
      </Box>

      {/* Services Section */}
      <Container
        maxWidth="lg"
        sx={{ mt: { xs: 6, md: 8 }, mb: 8, px: { xs: 2, md: 4 } }}
      >
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            mb: 6,
            fontWeight: 700,
            fontSize: { xs: 28, md: 40 },
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {t("Server") || "Our Services"}
        </Typography>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {services.map((service, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  padding: { xs: 3, md: 4 },
                  borderRadius: 4,
                  border: "1px solid",
                  borderColor: alpha(theme.palette.primary.main, 0.1),
                  background: "white",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background: service.gradient,
                    transform: "scaleX(0)",
                    transformOrigin: "left",
                    transition: "transform 0.4s ease",
                  },
                  "&:hover": {
                    transform: "translateY(-12px)",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                    "&::before": {
                      transform: "scaleX(1)",
                    },
                    "& .service-icon": {
                      transform: "scale(1.1) rotate(5deg)",
                    },
                  },
                }}
              >
                <Box
                  className="service-icon"
                  sx={{
                    width: { xs: 140, md: 180 },
                    height: { xs: 140, md: 180 },
                    borderRadius: "50%",
                    background: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 3,
                    transition: "transform 0.4s ease",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                    border: `3px solid`,
                    borderColor: alpha(theme.palette.primary.main, 0.1),
                    position: "relative",
                    overflow: "visible",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      inset: -4,
                      borderRadius: "50%",
                      background: service.gradient,
                      opacity: 0.1,
                      zIndex: -1,
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={service.icon}
                    alt={service.title}
                    sx={{
                      width: { xs: 100, md: 130 },
                      height: { xs: 100, md: 130 },
                      objectFit: "contain",
                      filter: "none",
                      zIndex: 1,
                    }}
                  />
                </Box>
                <CardContent sx={{ flexGrow: 1, px: 0 }}>
                  <Typography
                    variant="h5"
                    component={Link}
                    to={service.link}
                    sx={{
                      fontSize: { xs: 22, md: 28 },
                      fontWeight: 700,
                      color: "text.primary",
                      textDecoration: "none",
                      display: "block",
                      mb: 2,
                      transition: "color 0.3s ease",
                      "&:hover": {
                        color: "primary.main",
                      },
                    }}
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: 15, md: 18 },
                      color: "text.secondary",
                      lineHeight: 1.7,
                    }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Action Cards with Modern Design */}
        <Stack spacing={4}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.02 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                justifyContent: "space-between",
                padding: { xs: 4, md: 6 },
                background:
                  "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                borderRadius: 4,
                border: "1px solid",
                borderColor: alpha(theme.palette.primary.main, 0.2),
                gap: 4,
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
                  borderColor: alpha(theme.palette.primary.main, 0.4),
                },
              }}
            >
              <Box sx={{ flex: 2, textAlign: { xs: "center", md: textAlign } }}>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{
                    fontSize: { xs: 20, md: 26 },
                    fontWeight: 700,
                    mb: 1.5,
                    color: "text.primary",
                  }}
                >
                  {t("ContactTitle")}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: 16, md: 18 },
                    color: "text.secondary",
                    lineHeight: 1.7,
                  }}
                >
                  {t("ContactDeception")}
                </Typography>
              </Box>
              <Box sx={{ flex: 1, textAlign: "center" }}>
                <Button
                  variant="contained"
                  size={isMobile ? "medium" : "large"}
                  component={Link}
                  to="/ContactUs"
                  sx={{
                    textDecoration: "none",
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    fontWeight: 700,
                    px: { xs: 3, md: 5 },
                    py: { xs: 1.5, md: 2 },
                    borderRadius: 3,
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                      background:
                        "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                    },
                  }}
                >
                  {t("Contact")}
                </Button>
              </Box>
            </Paper>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.02 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          >
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                justifyContent: "space-between",
                padding: { xs: 4, md: 6 },
                background:
                  "linear-gradient(135deg, rgba(245, 87, 108, 0.1) 0%, rgba(240, 147, 251, 0.1) 100%)",
                borderRadius: 4,
                border: "1px solid",
                borderColor: alpha(theme.palette.secondary.main, 0.2),
                gap: 4,
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
                  borderColor: alpha(theme.palette.secondary.main, 0.4),
                },
              }}
            >
              <Box sx={{ flex: 2, textAlign: { xs: "center", md: textAlign } }}>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{
                    fontSize: { xs: 20, md: 26 },
                    fontWeight: 700,
                    mb: 1.5,
                    color: "text.primary",
                  }}
                >
                  {t("BookNowTitle")}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: 16, md: 18 },
                    color: "text.secondary",
                    lineHeight: 1.7,
                  }}
                >
                  {t("BookNowDeception")}
                </Typography>
              </Box>
              <Box sx={{ flex: 1, textAlign: "center" }}>
                <Button
                  variant="contained"
                  size={isMobile ? "medium" : "large"}
                  component={Link}
                  to="/Book_now"
                  sx={{
                    textDecoration: "none",
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    fontWeight: 700,
                    px: { xs: 3, md: 5 },
                    py: { xs: 1.5, md: 2 },
                    borderRadius: 3,
                    background:
                      "linear-gradient(135deg, #f5576c 0%, #f093fb 100%)",
                    boxShadow: "0 4px 15px rgba(245, 87, 108, 0.4)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 20px rgba(245, 87, 108, 0.6)",
                      background:
                        "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    },
                  }}
                >
                  {t("BookNowTop")}
                </Button>
              </Box>
            </Paper>
          </motion.div>

          {i18n.language !== "ku" && (
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ scale: 1.02 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
            >
              <Paper
                elevation={0}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: { xs: 4, md: 6 },
                  background:
                    "linear-gradient(135deg, rgba(79, 172, 254, 0.1) 0%, rgba(0, 242, 254, 0.1) 100%)",
                  borderRadius: 4,
                  border: "1px solid",
                  borderColor: alpha("#4facfe", 0.2),
                  gap: 4,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
                    borderColor: alpha("#4facfe", 0.4),
                  },
                }}
              >
                <Box
                  sx={{ flex: 2, textAlign: { xs: "center", md: textAlign } }}
                >
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{
                      fontSize: { xs: 20, md: 26 },
                      fontWeight: 700,
                      mb: 1.5,
                      color: "text.primary",
                    }}
                  >
                    Need to book a Remote Interpreter
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: 16, md: 18 },
                      color: "text.secondary",
                      lineHeight: 1.7,
                    }}
                  >
                    Click on the Book Button Now to get in touch
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, textAlign: "center" }}>
                  <Button
                    variant="contained"
                    size={isMobile ? "medium" : "large"}
                    component={Link}
                    to="/Book_now"
                    sx={{
                      textDecoration: "none",
                      fontSize: { xs: "1rem", md: "1.2rem" },
                      fontWeight: 700,
                      px: { xs: 3, md: 5 },
                      py: { xs: 1.5, md: 2 },
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                      boxShadow: "0 4px 15px rgba(79, 172, 254, 0.4)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 20px rgba(79, 172, 254, 0.6)",
                        background:
                          "linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)",
                      },
                    }}
                  >
                    Book Now
                  </Button>
                </Box>
              </Paper>
            </motion.div>
          )}
        </Stack>
      </Container>

      <ScrollToTop />
      <Footer />
    </Box>
  );
};

export default Home;
